import AppBar, {AppBarProps} from '@mui/material/AppBar';

import {styled} from '@mui/material/styles';

export const CAppBar = styled(AppBar)<AppBarProps>(
  (/* { theme } */) => ({
  }),
);
